var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024.003",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M832.254 385.075C827.532 210.86 684.34 70.58 509.006 70.58c-80.548 0-157.724 29.8-217.314 83.905-51.346 46.62-86.042 107.914-99.628 175.06-48.54 10.438-92.846 35.546-127.126 72.5C23.062 447.197 0 505.995 0 567.61c0 60.48 22.278 118.627 62.73 163.73 40.302 44.94 95.2 73.197 154.58 79.563l2.122.228h6.128v-77.147l.266-2.468-.266-.03v-.2h-1.742c-82.222-9.834-143.972-79.844-143.972-163.68 0-84.73 66.062-156.392 150.398-163.142l33.136-2.652 3.394-33.065c12.77-124.466 116.91-218.324 242.234-218.324 134.28 0 243.524 109.245 243.524 243.525v69.864h57.886c73.744 0 133.738 59.993 133.738 133.737s-59.994 133.738-133.738 133.738h-9.98v79.844h9.98c117.77 0 213.582-95.813 213.582-213.583 0-110.4-84.19-201.504-191.746-212.472zM670.69 680.82L550.924 800.584V403.927H471.08v396.658L351.314 680.82l-56.458 56.457 216.146 216.146 216.146-216.146z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.2aaa6c4b80741cd6c4f9e68fbb197352.svg";
export { ForwardRef as ReactComponent };